export default "__VITE_ASSET__BElf3UxJ__"